import { Outlet, Link } from "react-router-dom"
import { Button } from "../../components/buttons"

/*
Props:
*/

const JobSettings = () => {
  return (
    <div>
      JobSettings
      <Button link="../company"/>
    </div>
  )
}

export default JobSettings